import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import LHModalPop from '../../../components/LHModalPop';
import { RootState } from '../../../store/index';
import { hideErrorModal, removeErrorById } from '../../../store/slices/actionPlanSlice';

/**
 * Convert API name to user-friendly title format
 */
const getApiTitle = (apiName?: string): string => {
  if (!apiName) return 'Error';
  const words = apiName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
  return `${words} Failed`;
};

const ActionPlanErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const { activeError, isErrorModalVisible } = useSelector(
    (state: RootState) => state.actionPlan.centralizedErrors
  );

  const handleClose = () => {
    if (activeError) {
      dispatch(removeErrorById(activeError.id));
    }
    dispatch(hideErrorModal());
  };

  if (!activeError) return null;

  return (
    <LHModalPop
      visible={isErrorModalVisible}
      onClose={handleClose}
      title={getApiTitle(activeError.apiName)}
      description={activeError.message}
      showFooter={true}
      primaryButtonText="OK"
      secondaryButtonText=""
      onPrimaryPress={handleClose}
      showCloseButton={true}
    />
  );
};

const styles = StyleSheet.create({
  modalMessage: {
    fontSize: 16,
    color: '#3A3A3A',
    lineHeight: 24,
    textAlign: 'center',
    marginVertical: 10,
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
});

export default ActionPlanErrorModal;
